var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.93 0H0.747083C0.333853 0 0 0.335156 0 0.75V18C0 18.4148 0.333853 18.75 0.747083 18.75H17.93C18.3432 18.75 18.6771 18.4148 18.6771 18V0.75C18.6771 0.335156 18.3432 0 17.93 0ZM14.365 6.78984C14.372 6.9 14.372 7.01484 14.372 7.12734C14.372 10.568 11.7619 14.5312 6.99223 14.5312C5.52141 14.5312 4.15798 14.1023 3.00934 13.3641C3.21946 13.3875 3.42024 13.3969 3.63502 13.3969C4.84903 13.3969 5.96499 12.9844 6.85448 12.2859C5.71518 12.2625 4.75798 11.5125 4.43113 10.4813C4.83036 10.5398 5.18989 10.5398 5.60078 10.4344C5.01415 10.3147 4.48687 9.99488 4.10853 9.52918C3.73018 9.06348 3.5241 8.48064 3.5253 7.87969V7.84687C3.86849 8.04141 4.27238 8.16094 4.69495 8.17734C4.33972 7.93967 4.04839 7.61768 3.8468 7.23991C3.64521 6.86215 3.53959 6.44028 3.5393 6.01172C3.5393 5.52656 3.66537 5.08359 3.89183 4.69922C4.54297 5.50391 5.35549 6.16205 6.27658 6.63086C7.19767 7.09966 8.20672 7.36864 9.23814 7.42031C8.87161 5.65078 10.1883 4.21875 11.7712 4.21875C12.5183 4.21875 13.1907 4.53281 13.6646 5.03906C14.2506 4.92891 14.8109 4.70859 15.3105 4.41328C15.1167 5.01562 14.7105 5.52422 14.1712 5.84531C14.6942 5.78906 15.1985 5.64375 15.6654 5.43984C15.3129 5.96016 14.8716 6.42188 14.365 6.78984Z",
    fill: "#FFFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.b9c519b652cbc31d17bbcd6bdfed1aef.svg";
export { ForwardRef as ReactComponent };